
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.589 3.476h-1.598V1.878c0-.587-.478-1.065-1.065-1.065h-2.131c-.587 0-1.065.478-1.065 1.065v1.598H8.271V1.878c0-.587-.478-1.065-1.065-1.065H5.074c-.587 0-1.065.478-1.065 1.065v1.598H2.411A1.6 1.6 0 00.813 5.074v16.515a1.6 1.6 0 001.598 1.598H21.59a1.6 1.6 0 001.598-1.598V5.074a1.6 1.6 0 00-1.599-1.598zm-4.794-1.598h2.131v3.196h-2.131V1.878zm-11.721 0h2.131v3.196H5.074V1.878zm17.048 19.711a.533.533 0 01-.533.533H2.411a.533.533 0 01-.533-.533V9.869h20.244v11.72zm0-12.785H1.878v-3.73c0-.294.239-.533.533-.533h1.598V6.14h4.262V4.542h7.458V6.14h4.262V4.542h1.598c.294 0 .533.239.533.533v3.729z"}}),_c('path',{attrs:{"d":"M13.22 12.533h2.131v1.065H13.22zM17.482 12.533h2.131v1.065h-2.131zM8.958 15.196h2.131v1.065H8.958zM13.22 15.196h2.131v1.065H13.22zM17.482 15.196h2.131v1.065h-2.131zM8.958 17.86h2.131v1.065H8.958zM13.22 17.86h2.131v1.065H13.22zM17.482 17.86h2.131v1.065h-2.131z"}}),_c('text',{attrs:{"y":"39","font-size":"5","font-weight":"bold","font-family":"'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"}},[_v('Created by Storm Icons')]),_c('text',{attrs:{"y":"44","font-size":"5","font-weight":"bold","font-family":"'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"}},[_v('from the Noun Project')])])
          )
        }
      }
    